import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AgeSegment, TimeZone } from '../models/system/system-models';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiPagedResponse, ApiResponse } from '../models/api-response';
import { settings } from '../shared/globals/settings';
import { Locale } from '../models/internationalization/internationalization-models';

@Injectable({
  providedIn: 'root'
})
export class SystemService {
  private readonly _http = inject(HttpClient);


  locales$ = new BehaviorSubject<Locale[] | null>(null);

  public getAllTimeZones(pageNumber: number, pageSize: number): Observable<ApiPagedResponse<TimeZone>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize);
    return this._http.get<ApiPagedResponse<TimeZone>>(`${settings.endpoints.gameApiRoot}/api/system/timezones`, { params: params });
  }

  public getAllAgeSegments(): Observable<ApiResponse<AgeSegment[]>> {
    return this._http.get<ApiResponse<AgeSegment[]>>(`${settings.endpoints.gameApiRoot}/api/system/agesegments`);
  }

  public getLocales(): Observable<ApiResponse<Locale[]>> {
    return this._http.get<ApiResponse<Locale[]>>(`${settings.endpoints.gameApiRoot}/api/system/locales`);
  }
}
